export default "__VITE_ASSET__1ba0dcfe__"